/**
 * Model reprezentujący blokady czasowe (niedostępność) w grafiku pracy lekarza dla danego dnia.
 * Wykorzystywany przez silnik kalendarza do wykluczania konkretnych przedziałów czasowych
 * z puli terminów udostępnianych pacjentom do rezerwacji.
 */
export class DaySettings {

  /** Identyfikator dnia (dzień tygodnia dla standardowych blokad lub YYYY-MM-DD dla niestandardowych niedostępności).
   */
  public day: string;

  /** Godzina rozpoczęcia niedostępności (np. "12:00").
   */
  public startTime: string;

  /** Godzina zakończenia niedostępności (np. "12:30").
   */
  public endTime: string;

  /** Flaga oznaczająca całodniową niedostępność.
   */
  public isFullDay: boolean;

  constructor() {
  }

}
